import styled from "styled-components";
import theme from "theme";
import { colors } from "theme/colors";
import Text from "../../../Text";
import { OptionStyledProps } from "./types";

export const Option = styled("li")<OptionStyledProps>`
    cursor: pointer;
    padding: 0px 0.8rem;
    border-radius: 0.5rem;
    box-sizing: border-box;
    min-height: 2rem;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    position: relative;
    background-color: ${theme.colors.white};
    min-width: fit-content;
    & > ${Text.Style} {
        flex: 1;
        user-select: none;
        white-space: nowrap;
        color: ${theme.colors.text};
    }
    &:hover {
        background-color: ${colors.grey.tertiary};
    }
`;
